import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Toolbar, Typography, Tooltip, IconButton, Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import { getAletsData } from 'store/alerts';

import useAlerts from 'hooks/useAlerts';

const EnhancedTableToolbar = () => {
  const aletsData = useSelector(getAletsData);
  const { handleDeleteAlert } = useAlerts();
  const [numSelected, setNumSelected] = useState(0);

  useEffect(() => {
    const alerts = aletsData.filter((item) => item.isSelected) || [];

    setNumSelected(alerts?.length || 0);
  }, [aletsData]);

  return (
    <Toolbar>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <Typography color="inherit" variant="subtitle1" component="div">
          {numSelected} Selecionados
        </Typography>

        <Tooltip title="Eliminar">
          <IconButton
            aria-label="delete"
            disabled={!numSelected}
            onClick={handleDeleteAlert}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Toolbar>
  );
};

export default EnhancedTableToolbar;
